import { Mail, Link2, Clock } from 'lucide-react';

export default function Contact() {
  return (
    <section id="contact" className="contact-section">
      <div className="section-inner contact-inner">
        <h2 className="section-title contact-title">
          Ready to take your project<br />to production?
        </h2>
        <p className="contact-subtitle">
          Got a vibe-coded prototype that needs hardening, a product idea you want to ship,
          or a tech problem that's been blocking you — let's talk.
        </p>

        <div className="contact-cards">
          <a href="mailto:hello@seacloud-software.hr" className="contact-card">
            <Mail size={22} className="contact-card-icon" />
            <div>
              <p className="contact-card-label">Email</p>
              <p className="contact-card-value">Send us a message</p>
              <p className="contact-card-tz">hello@seacloud-software.hr</p>
            </div>
          </a>

          <a
            href="https://www.linkedin.com/company/seacloud-sw"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-card"
          >
            <Link2 size={22} className="contact-card-icon" />
            <div>
              <p className="contact-card-label">LinkedIn</p>
              <p className="contact-card-value">SeaCloud Software</p>
              <p className="contact-card-tz">Follow us for updates</p>
            </div>
          </a>

          <div className="contact-card contact-card-static">
            <Clock size={22} className="contact-card-icon" />
            <div>
              <p className="contact-card-label">Availability</p>
              <p className="contact-card-value">US &amp; EU hours covered</p>
              <p className="contact-card-tz">Mon–Fri · overlaps with EST &amp; PST mornings</p>
            </div>
          </div>
        </div>

        <div className="contact-footer">
          <a href="/legal" className="footer-link">Legal Notice</a>
          <span className="footer-sep">·</span>
          <a href="/privacy" className="footer-link">Privacy Policy</a>
          <span className="footer-sep">·</span>
          <span className="footer-copy">© {new Date().getFullYear()} SeaCloud Software d.o.o.</span>
        </div>
      </div>
    </section>
  );
}
